import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory, withRouter } from 'react-router';

class RouteTransitionPrompt extends React.Component {
  static propTypes = {
    shouldPromptUser: PropTypes.bool,
    router: PropTypes.object,
    route: PropTypes.object,
    PromptModal: PropTypes.func.isRequired,
    onCancelAction: PropTypes.func,
    onSubmitAction: PropTypes.func,
    onContinueAction: PropTypes.func,
    onDisregardAction: PropTypes.func,
    hasLinksAndProfilesChanges: PropTypes.bool,
    hasMediaChanges: PropTypes.bool,
    hasIntroChanges: PropTypes.bool,
    hasBasicInfoChanges: PropTypes.bool,
  };

  state = {
    nextLocation: {},
    showPromptModal: false,
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.shouldPromptUser) {
      this.removeListener = this.props.router.setRouteLeaveHook(this.props.route, this.leaveRouteHandler);
    }
    if (this.props.shouldPromptUser && !nextProps.shouldPromptUser && this.removeListener) {
      this.removeListener();
    }
  }

  componentWillUnmount = () => {
    if (this.props.shouldPromptUser && this.removeListener) this.removeListener();
  }

  onClosePrompt = () => {
    const { onCancelAction } = this.props;
    if (onCancelAction) onCancelAction();
    this.setState({ showPromptModal: false });
  }

  onSubmitPrompt = async () => {
    const { onSubmitAction } = this.props;
    if (onSubmitAction) await onSubmitAction();
    this.setState({ showPromptModal: false });
    this.onContinuePrompt();
  }

  onContinuePrompt = () => {
    const { nextLocation } = this.state;
    const { onContinueAction } = this.props;
    if (onContinueAction) onContinueAction();
    this.removeListener();
    browserHistory.push(nextLocation);
  }

  leaveRouteHandler = (nextLocation) => {
    this.setState({
      nextLocation,
      showPromptModal: true,
    });
    return false;
  }

  handleDisregard = () => {
    this.props.onDisregardAction();
    this.onContinuePrompt();
  }

  render() {
    const { PromptModal, hasLinksAndProfilesChanges, hasMediaChanges, hasIntroChanges, hasBasicInfoChanges, ...rest } = this.props;
    const { showPromptModal } = this.state;
    return (
      <PromptModal
        open={showPromptModal}
        onClose={this.onClosePrompt}
        onSubmit={this.onSubmitPrompt}
        onContinue={this.onContinuePrompt}
        onDisregard={this.handleDisregard}
        hasLinksAndProfilesChanges={hasLinksAndProfilesChanges}
        hasMediaChanges={hasMediaChanges}
        hasIntroChanges={hasIntroChanges}
        basicInfoChanges={hasBasicInfoChanges}
        {...rest}
      />
    );
  }
}

export default withRouter(RouteTransitionPrompt);
